import hpten from './hpten';
// import xyrb from './xyrb';
// import pk10 from './pk10';
import ks from './ks';

export default (type, data, ballindex, Vue) => {
  if (type == 'hpten') {
    return hpten(data, ballindex);
  }
  // if (type == 'xyrb') {
  //   return xyrb(data);
  // }
  // if (type == 'PK10' || type == 'nn') {
  //   return pk10(data);
  // }
  if (type == 'ks') {
    // console.log('ks');

    return ks(data, ballindex);
  }
};



// WEBPACK FOOTER //
// ./src/pages/Trend/Jiouzoushi/columns/index.js